import classNames from 'classnames';
import * as React from 'react';
import IMask from 'yndx-mask';

import { Bem } from '../../service/Bem/Bem';
import { Omit } from '../../typings/utils';
import { TextInputDecorator, TextInputDecoratorProps } from '../TextInputDecorator/TextInputDecorator';

export type MaskedTextInputProps = {
    cls?: string;
    maskOptions: IMask.AnyMaskedOptions;
    onChange?: (value: string) => void;
} & Omit<TextInputDecoratorProps, 'onChange'>;

export interface MaskedTextInputState {
    inputMask?: IMask.InputMask<IMask.AnyMaskedOptions>;
}

const BLOCK = 'masked-text-input';

// полная документация по библиотеке imask находится по адресу https://unmanner.github.io/imaskjs/guide.html
export class MaskedTextInput extends React.PureComponent<MaskedTextInputProps, MaskedTextInputState> {
    private textInputDecorator: TextInputDecorator;

    static getDerivedStateFromProps(nextProps: MaskedTextInputProps, prevState: MaskedTextInputState) {
        const { inputMask } = prevState;
        const { text } = nextProps;

        if (inputMask && text !== inputMask.value) {
            inputMask.value = text !== undefined ? String(text) : '';

            return {
                inputMask: inputMask
            };
        }

        return null;
    }

    constructor(props: MaskedTextInputProps) {
        super(props);

        this.state = {
            inputMask: undefined
        };
    }

    componentWillUnmount() {
        const { inputMask } = this.state;

        if (inputMask) {
            inputMask.off('accept', this.onChange);
        }
    }

    componentDidMount() {
        const { text = '', maskOptions } = this.props;

        if (this.textInputDecorator.textInput === null) {
            return;
        }

        const inputMask = IMask(this.textInputDecorator.textInput._control, maskOptions);
        inputMask.value = String(text);

        this.setState({
            inputMask: inputMask
        });

        inputMask.on('accept', this.onChange);
    }

    render() {
        const { text, onChange, cls, ...otherProps } = this.props;
        const { inputMask } = this.state;

        const value = inputMask ? inputMask.value : '';

        return (
            <TextInputDecorator
                cls={classNames(Bem.cls(BLOCK), cls)}
                ref={this.setRef}
                text={value}
                onChange={this.onChange}
                {...otherProps}
            />
        );
    }

    private onChange = (value: string) => {
        const { inputMask } = this.state;
        const { onChange } = this.props;

        if (onChange) {
            // обработка нажатия на крестик поля
            if (value === '') {
                onChange(value);
            } else if (inputMask !== undefined) {
                onChange(inputMask.value);
            }
        }
    };

    private setRef = (node: TextInputDecorator) => {
        this.textInputDecorator = node;
    };
}
